import styled from 'styled-components';

export default styled.section`
  padding: 3.1875rem ${props => props.theme.padding.inner} 3.75rem;

  @media (min-width: ${props => props.theme.breakpoints.desktop}) {
    padding: 6.1875rem ${props => props.theme.padding.inner} 2.625rem;
    border-bottom: solid 1px ${props => props.theme.colors.grey5};
  }

  .inner {
    margin: auto;
    max-width: ${props => props.theme.maxWidths.containerSmall};

    @media (min-width: ${props => props.theme.breakpoints.desktop}) {
      max-width: ${props => props.theme.maxWidths.container};
    }
  }

  header {
    margin-bottom: 1.9375rem;

    @media (min-width: ${props => props.theme.breakpoints.desktop}) {
      margin-bottom: 3.6875rem;
    }

    @media (prefers-reduced-motion: no-preference) {
      .isAnimated& {
        opacity: 0;
        transform: translateY(10px);
      }

      .active& {
        animation: 0.4s ease-in-out slide-in-up forwards;
      }
    }

    h2 {
      margin: 0;
    }
  }

  .calculators {
    ul {
      margin: 0;
      padding: 0;
      list-style: none;
      display: flex;
      flex-direction: column;

      @media (min-width: ${props => props.theme.breakpoints.desktop}) {
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: flex-start;
      }
    }

    li {
      padding: 0 0 2.875rem 0;

      @media (min-width: ${props => props.theme.breakpoints.desktop}) {
        flex: 0 0 33.33%;
        padding: 0 0 3.8125rem 0;
      }

      @media (prefers-reduced-motion: no-preference) {
        .isAnimated& {
          opacity: 0;
          transform: translateY(10px);
        }

        .active& {
          animation: 0.4s ease-in-out slide-in-up forwards;
        }
      }

      a {
        margin: 0;
        font-size: ${props => props.theme.type.button.large};
        line-height: ${props => props.theme.lineHeights.button.large};
        letter-spacing: ${props => props.theme.letterSpacing.button};
        font-weight: 600;
      }

      p {
        margin: 0;
        font-size: ${props => props.theme.type.caption};
        line-height: ${props => props.theme.lineHeights.caption};
        letter-spacing: ${props => props.theme.letterSpacing.caption};
      }
    }
  }

  ${props => props.theme.animations.slideInUp};
`;
